import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { BACKOFFICE_WS_ROOM_ID } from '../constants';
import { USER_ROLES } from '../constants/keycloak';
import { getItemFromSessionStorage } from '../utils/storageHelper';
import usePermissions from './usePermissions';

/** Socket room the feed API notifies about ticket authorization events for the active marketplace. */
const useTicketAuthorizationRoomId = (): string => {
  const { marketplaceId } = useAuth();
  const { role } = usePermissions();

  if (role === USER_ROLES.SUPER_ADMIN) {
    return `${BACKOFFICE_WS_ROOM_ID}_${getItemFromSessionStorage('marketplace')?.id}`;
  }

  return `${BACKOFFICE_WS_ROOM_ID}_${marketplaceId}`;
};

export default useTicketAuthorizationRoomId;
